import {
  ChangePasswordRequest,
  CheckResetCodeRequest,
  TopLevelUserModel,
} from './models';
import { createMutation, createQuery } from '../../libs';

import { CheckEmailRequest } from '@/features/login-and-signup/services/types';

const url = 'auth';

export const useMe = createQuery<TopLevelUserModel>({
  method: 'get',
  url: `${url}/me`,
});

export const useSendResetCode = createMutation<unknown, CheckEmailRequest>({
  method: 'post',
  url: `${url}/forget-password`,
});

export const useVerifyResetCode = createMutation<unknown, CheckResetCodeRequest>({
  method: 'post',
  url: `${url}/reset-password-code`,
});

export const useChangePassword = createMutation<unknown, ChangePasswordRequest>({
  method: 'post',
  url: `${url}/reset-password-confirmation`,
});

export const useDeleteAccount = createMutation({
  method: 'delete',
  url: `${url}/delete-account`,
});

export const useAddToken = createMutation({
  method: 'post',
  url: `${url}/add-token`,
});

export const useLogout = createMutation({
  method: 'post',
  url: `${url}/logout`,
});

export const useUnverifiedUser = createMutation({
  method: 'post',
  url: `${url}/unverified-user`,
});
